import React, { useEffect, useState, useRef } from "react";
import { View, ScrollView, Text, ImageBackground, SafeAreaView, TouchableOpacity, Image, Linking, ActivityIndicator, Modal, Dimensions } from "react-native";
import { useNavigation } from "@react-navigation/native";
import MobileHeader from "../components/mHeader";
import Footer from "../components/footer";
import Header from "../components/header";
import i18n from "../components/i18n";
import CookieConsent from "../components/CookieConsent";
import NewMobileHeader from "../components/newMobileHeader";
import AsyncStorage from "../components/AsyncStorage";
import axios from "axios";
import { API_MIDDLEWARE, API_REGION } from "@env";
import { region } from "expo-localization";
import { WebView } from "react-native-webview";
import loyalty from "../api/loyalty";

let keepCheck
let paymentCheckCount = 1

const ShoppingCart = () => {
    const navigation = useNavigation();
    const [lang, setLang] = useState("en");
    const [isLoading, setIsLoading] = useState(false);
    const [overlay, setOverlay] = useState(false)
    const [memberCode, setMemberCode] = useState("");
    const [memberRegion, setMemberRegion] = useState("");
    const [member, setMember] = useState({})
    const [isLoggedIn, setIsLoggedIn] = useState(false)
    const [items, setItems] = useState({
        "100": 0,
        "500": 0,
        "1000": 0
    })
    const [haveItems, setHaveItems] = useState(true)
    const [paymentWebview, setPaymentWebview] = useState(false);
    const [paymentURL, setPaymentURL] = useState("");
    const [paymentDetail, setPaymentDetail] = useState({
        invoiceNo: "",
        desc: "",
        amount: "",
    });
    const [initChecking, setInitChecking] = useState(true)
    const [payStatus, setPayStatus] = useState('')
    const [cartTot, setCartTot] = useState("0")
    const [paymentRemain, setPaymentRemain] = useState(20 * 60)
    const paymentStartRef = useRef(null)
    const paymentTimerRef = useRef(null)

    const mounted = useRef(false);

    const formatCountdown = (secs) => {
        if (secs < 0) secs = 0
        const m = Math.floor(secs / 60)
        const s = secs % 60
        return `${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`
    }

    useEffect(() => {
        mounted.current = true;

        AsyncStorage.getData("mCode").then((value) => {
            if (!value) {
                //navigation.push("Login");
            } else {
                setIsLoggedIn(true)
                let loginDetail = JSON.parse(value);
                console.log(loginDetail)
                setMemberCode(loginDetail.code);
                setMemberRegion(loginDetail.region);

                let data = {
                    code: loginDetail.code,
                    username: loginDetail.username,
                    region: loginDetail.region,
                };

                customerGet(data, (customer) => {
                    setMember(customer)
                })

                AsyncStorage.getData("shoppingcart").then((coupons) => {
                    console.log(coupons)
                    if (coupons) {
                        let couponItems = JSON.parse(coupons)
                        couponItems = calTotal(couponItems)
                        setItems(couponItems)

                        if (couponItems['100'] != 0 && couponItems['500'] != 0 && couponItems['1000'] != 0) {
                            setHaveItems(true)
                        }
                    } else {
                        setHaveItems(false)
                    }
                })
            }
        })

        AsyncStorage.getData("lang").then((lang) => {
            if (lang) {
                setLang(lang)
            }
        });

        return () => {
            mounted.current = false;
        };
    }, []);

    const plusItem = (type) => {
        var cart = {}
        AsyncStorage.getData("shoppingcart").then((value) => {
            if (!value) {
                cart = {
                    "100": 0,
                    "500": 0,
                    "1000": 0
                }
            } else {
                cart = JSON.parse(value)
            }

            cart[type] = cart[type] + 1

            AsyncStorage.storeData("shoppingcart", JSON.stringify(cart))

            cart = calTotal(cart)
            setItems(cart)
        })
    }

    const minusItem = (type) => {
        var cart = {}
        AsyncStorage.getData("shoppingcart").then((value) => {
            if (!value) {
                cart = {
                    "100": 0,
                    "500": 0,
                    "1000": 0
                }
            } else {
                cart = JSON.parse(value)
            }

            if (cart[type] > 0) {
                cart[type] = cart[type] - 1
            }

            AsyncStorage.storeData("shoppingcart", JSON.stringify(cart))

            cart = calTotal(cart)
            setItems(cart)
        })
    }

    const calTotal = (items) => {
        items.total100 = items['100'] * 475
        items.total500 = items['500'] * 900
        items.total1000 = items['1000'] * 4400
        items.total = (items.total100 + items.total500 + items.total1000).toLocaleString()

        if (items['100'] == 0 && items['500'] == 0 && items['1000'] == 0) {
            setHaveItems(false)
        }

        let total = items["100"] + items["500"] + items["1000"]

        setCartTot(total.toLocaleString().toString())

        return items
    }

    const customerGet = (data, callback) => {
        console.log("customer get")
        let formdata = {
            method: "getCust",
            //username: data.username,
            code: data.code,
            region: data.region
        }

        loyalty.api(formdata).then((res) => {
            callback(res)
        })
    };

    const initPayment = () => {
        setIsLoading(true);

        let data = {
            code: memberCode,
            voucher: {}
        }

        if (items['100'] > 0) {
            data.voucher['500ITCHKDINEV'] = items['100']
        }

        if (items['500'] > 0) {
            data.voucher['1000ITCHKDINEV'] = items['500']
        }

        if (items['1000'] > 0) {
            data.voucher['5000ITCHKDINEV'] = items['1000']
        }

        console.log(data)

        getPaymentURL(data, (pay) => {
            if (pay.status == "success") {
                setPaymentURL(pay.url);

                let payD = paymentDetail;
                payD.invoiceNo = pay.invoiceno;
                payD.desc = pay.description;
                payD.amount = pay.amount;

                console.log("Payment detail :", paymentDetail);

                setPaymentDetail(payD);
                paymentStartRef.current = Date.now();
                setPaymentRemain(20 * 60);
                startPaymentCountdown();
                setPaymentWebview(true);
                setIsLoading(false);
                //keepCheckPayment()
            } else {
                console.log("Init payment failed");
                setIsLoading(false);
            }
        });
    };

    let isRunning = false

    const checkPayment = () => {
        let time = randNum();

        setTimeout(() => {
            if (!isRunning) {
                isRunning = true

        let data = {
            invoiceNo: paymentDetail.invoiceNo,
        };

        checkPaymentResult(data, (result) => {
            if (result.respCode == "0000") {
                clearKeepCheckPayment();

                confirmBuy({
                    code: memberCode,
                    invoiceNo: paymentDetail.invoiceNo
                }, res => {
                    if (res.status == "success") {
                        setIsLoading(false)
                        setPayStatus("success")
                        console.log("Payment success")
                        AsyncStorage.removeValue("shoppingcart")
                        setOverlay(true)
                    } else {
                        alert("Issued coupon failed!")
                    }
                })
            } else if (result.respCode == "0003") {
                console.log("Payment cancelled")
                setPayStatus("failed")
                setIsLoading(false)
                isRunning = false
                clearKeepCheckPayment();
                setOverlay(true)
            } else if (result.respCode == "0001" || result.respCode == "2001" || result.respCode == "4009" || result.respCode == "4090") {
                if (paymentCheckCount <= 6) {
                    setTimeout(() => {
                        console.log("retry payment check " + paymentCheckCount)
                        checkPayment()
                    }, 10000)

                    paymentCheckCount = paymentCheckCount + 1
                } else {
                    console.log("Payment cancelled")
                    setPayStatus("failed")
                    setIsLoading(false)
                    clearKeepCheckPayment();
                    setOverlay(true)
                    isRunning = false
                }
            } else {
                console.log("Payment failed")
                setPayStatus("failed")
                setIsLoading(false)
                clearKeepCheckPayment();
                setOverlay(true)
                isRunning = false
            }
        });
    }
        }, time * 1000)
    }

    const randNum = () => {
        return Math.floor(Math.random() * 5);
    };

    const keepCheckPayment = () => {
        keepCheck = window.setInterval((() => {
            checkPayment()
        }), 10000);
    }

    const clearKeepCheckPayment = () => {
        window.clearInterval(keepCheck)
    }

    const startPaymentCountdown = () => {
        if (paymentTimerRef.current) {
            clearInterval(paymentTimerRef.current)
            paymentTimerRef.current = null
        }

        paymentTimerRef.current = setInterval(() => {
            const remainMs = 20 * 60 * 1000 - (Date.now() - paymentStartRef.current)

            if (remainMs > 0) {
                setPaymentRemain(Math.ceil(remainMs / 1000))
            } else {
                clearInterval(paymentTimerRef.current)
                paymentTimerRef.current = null
                setPaymentRemain(0)
                setPaymentWebview(false)
                clearKeepCheckPayment()
                alert(`${i18n.t("promotions.payment_expired")}`)
                //alert("The payment process has expired. Please start the payment process again.")
            }
        }, 1000)
    }

    useEffect(() => {
        if (!paymentWebview && paymentTimerRef.current) {
            clearInterval(paymentTimerRef.current)
            paymentTimerRef.current = null
        }
    }, [paymentWebview])

    useEffect(() => {
        return () => {
            if (paymentTimerRef.current) {
                clearInterval(paymentTimerRef.current)
                paymentTimerRef.current = null
            }
        }
    }, [])

    const getPaymentURL = (data, callback) => {
        let formdata = {
            method: "buyCoupon",            
            code: data.code,
            voucher: JSON.stringify(data.voucher),
            region: API_REGION
        }

        loyalty.api(formdata).then((res) => {
            callback(res)
        })
    };

    const checkPaymentResult = (data, callback) => {
        let formdata = {
            method: "paymentChk",            
            invoiceno: data.invoiceNo,
            region: API_REGION
        }

        loyalty.api(formdata).then((res) => {
            callback(res)
        })
    };

    const confirmBuy = (data, callback) => {
        let formdata = {
            method: "confirmBuyCoupon",
            code: data.code,            
            invoiceno: data.invoiceNo,
            region: API_REGION
        }

        loyalty.api(formdata).then((res) => {
            callback(res)
        })
    };

    const callbackLog = (data, callback) => {
        let formdata = {
            method: "cblog",
            log: data.log,            
            type: "payment",
            src: "web",
            memberCode: data.memberCode,
            invoiceno: data.invoiceno,
            region: API_REGION
        }

        loyalty.api(formdata).then((res) => {
            callback(res)
        })
    }

    return (
        <View className="flex-1 md:bg-[#efefef] w-full" pointerEvents={!isLoading ? "auto" : "none"}>
            <ImageBackground source={require("../assets/login-bg.png")} resizeMode="cover" className="flex-1 justify-start items-center w-full h-full">
                {isLoading && (
                    <View
                        className="left-0 right-0 top-0 bottom-0 justify-center items-center bg-[#f3f3f394] z-10 w-full h-full"
                        style={{ position: "fixed" }}
                        pointerEvents={"none"}
                    >
                        <ActivityIndicator size="large" color={"#BD9B60"} />
                    </View>
                )}
                <SafeAreaView className="flex-1 bg-white flex justify-start items-center w-full md:bg-transparent">
                    <NewMobileHeader cartTotal={cartTot} />
                    {/* <MobileHeader title={i18n.t("mobileApp.title")} /> */}
                    <ScrollView className="w-full flex-1">
                        <Header cartTotal={cartTot} />
                        <View className="items-center content-start">
                            <View className="w-11/12 md:w-4/5 md:max-w-screen-xl md:h-auto md:m-auto md:bg-white md:p-7 mt-6 md:mb-24 pb-10 md:px-20">
                                {
                                    isLoggedIn &&
                                    <Text className="text-brandgold text-lg mb-2 uppercase font-Crimson text-center">{i18n.t("promotions.welcome")}, {member.title} {member.last_name}!</Text>
                                }
                                {/* {
                                    !isLoggedIn &&
                                    <Text className="text-brandgold text-lg mb-6 uppercase font-Crimson text-center">{i18n.t("promotions.welcome")}!</Text>
                                } */}
                                <Text className="text-brandgold text-2xl mt-6 font-Crimson text-center">{i18n.t("promotions.intro1")}</Text>
                                <Text className="text-black text-lg mt-0 mb-2 font-Crimson text-center">{i18n.t("promotions.intro2")}</Text>

                                <Text className="text-sm text-[#84818A] text-center mb-6">{i18n.t("promotions.notes")}</Text>
                                {/* <Text className="text-black text-2xl mb-1 uppercase font-Crimson text-center">{i18n.t("promotions.intro1")}{"\n"}{i18n.t("promotions.intro2")}</Text> */}

                                {/* <Text className="text-[#84818A] text-sm mb-6 uppercase font-Crimson text-center">{i18n.t("passport.period")}</Text> */}

                                <View className="w-full flex flex-col">
                                    <View className="w-full flex flex-row justify-start items-center bg-gray-200 py-2 px-4">
                                        <Text className="text-base text-black font-bold">{i18n.t("promotions.cart")}</Text>
                                        {/* <View className="w-3/5">
                                            <Text className="text-base text-black font-bold font-NunitoSans">e-vouchers</Text>
                                        </View>
                                        <View className="w-1/5">
                                            <Text className="text-base text-black font-bold font-NunitoSans">Quantity</Text>
                                        </View>
                                        <View className="w-1/5">
                                            <Text className="text-base text-black font-bold font-NunitoSans">Total</Text>
                                        </View> */}
                                    </View>
                                    {
                                        !haveItems &&
                                        <View className="w-full flex flex-row justify-center items-center py-24 border-b border-gray-200">
                                            <Text className="text-base text-black font-bold">No items</Text>
                                        </View>
                                    }

                                    {
                                        items['100'] > 0 &&
                                        <View className="w-full flex flex-row justify-start items-center flex-wrap py-6 px-4 border-b border-gray-200">
                                            <View className="w-full flex flex-col justify-start items-center lg:w-3/5 lg:flex-row lg:justify-start lg:items-center">
                                                {/* <View className="w-full h-44 lg:w-44 lg:h-28 bg-gray-200 rounded-2xl mr-2"></View> */}
                                                <View className="w-full lg:w-44 lg:mr-2">
                                                    <Image style={{ width: "100%", aspectRatio: 1 }} source={require("../assets/promotions/hkd-500.png")} resizeMode="contain" />
                                                </View>
                                                <View className="w-full mt-3 lg:mt-0">
                                                    <Text className="text-base md:text-base text-black font-bold text-center lg:text-left">HKD$500 {i18n.t("promotions.evoucher")}</Text>
                                                    <Text className="text-base md:text-base text-brandgold font-bold text-center lg:text-left mt-2 md:mt-0">HKD$475 ({i18n.t("promotions.save")} 5%) </Text>
                                                </View>
                                            </View>
                                            <View className="w-3/5 lg:w-1/5 flex flex-row items-center mt-3 lg:mt-0 justify-start lg:justify-center">
                                                <TouchableOpacity className="w-7 h-7 max-h-7 bg-brandgold" onPress={() => { minusItem('100') }}>
                                                    <Text className="text-white w-full h-7 leading-7 text-center font-normal">-</Text>
                                                </TouchableOpacity>
                                                <Text className="text-base text-black font-bold text-right lg:text-left leading-7 mx-3">{items['100']}</Text>
                                                <TouchableOpacity className="w-7 h-7 max-h-7 bg-brandgold" onPress={() => { plusItem('100') }}>
                                                    <Text className="text-white w-full h-7 leading-7 text-center font-normal">+</Text>
                                                </TouchableOpacity>
                                            </View>
                                            <View className="w-2/5 lg:w-1/5 mt-3 lg:mt-0">
                                                <Text className="text-base text-black font-bold text-right lg:text-center">HKD${items.total100.toLocaleString()}</Text>
                                            </View>
                                        </View>
                                    }

                                    {
                                        items['500'] > 0 &&
                                        <View className="w-full flex flex-row justify-start items-center flex-wrap py-6 px-4 border-b border-gray-200">
                                            <View className="w-full flex flex-col justify-start items-center lg:w-3/5 lg:flex-row lg:justify-start lg:items-center">
                                                <View className="w-full lg:w-44 lg:mr-2">
                                                    <Image style={{ width: "100%", aspectRatio: 1 }} source={require("../assets/promotions/hkd-1000.png")} resizeMode="contain" />
                                                </View>
                                                <View className="w-full mt-3 lg:mt-0">
                                                    <Text className="text-base md:text-base text-black font-bold text-center lg:text-left">HKD$1,000 {i18n.t("promotions.evoucher")}</Text>
                                                    <Text className="text-base md:text-base text-brandgold font-bold text-center lg:text-left mt-2 md:mt-0">HKD$900 ({i18n.t("promotions.save")} 10%) </Text>
                                                </View>
                                            </View>
                                            <View className="w-3/5 lg:w-1/5 flex flex-row items-center mt-3 lg:mt-0 justify-start lg:justify-center">
                                                <TouchableOpacity className="w-7 h-7 max-h-7 bg-brandgold" onPress={() => { minusItem('500') }}>
                                                    <Text className="text-white w-full h-7 leading-7 text-center font-normal">-</Text>
                                                </TouchableOpacity>
                                                <Text className="text-base text-black font-bold text-right lg:text-left leading-7 mx-3">{items['500']}</Text>
                                                <TouchableOpacity className="w-7 h-7 max-h-7 bg-brandgold" onPress={() => { plusItem('500') }}>
                                                    <Text className="text-white w-full h-7 leading-7 text-center font-normal">+</Text>
                                                </TouchableOpacity>
                                            </View>
                                            <View className="w-2/5 lg:w-1/5 mt-3 lg:mt-0">
                                                <Text className="text-base text-black font-bold text-right lg:text-center">HKD${items.total500.toLocaleString()}</Text>
                                            </View>
                                        </View>
                                    }

                                    {
                                        items['1000'] > 0 &&
                                        <View className="w-full flex flex-row justify-start items-center flex-wrap py-6 px-4 border-b border-gray-200">
                                            <View className="w-full flex flex-col justify-start items-center lg:w-3/5 lg:flex-row lg:justify-start lg:items-center">
                                                <View className="w-full lg:w-44 lg:mr-2">
                                                    <Image style={{ width: "100%", aspectRatio: 1 }} source={require("../assets/promotions/hkd-5000.png")} resizeMode="contain" />
                                                </View>

                                                <View className="w-full mt-3 lg:mt-0">
                                                    <Text className="text-base md:text-base text-black font-bold text-center lg:text-left">HKD$5,000 {i18n.t("promotions.evoucher")}</Text>
                                                    <Text className="text-base md:text-base text-brandgold font-bold text-center lg:text-left mt-2 md:mt-0">HKD$4,400 ({i18n.t("promotions.save")} 12%) </Text>
                                                </View>
                                            </View>
                                            <View className="w-3/5 lg:w-1/5 flex flex-row items-center mt-3 lg:mt-0 justify-start lg:justify-center">
                                                <TouchableOpacity className="w-7 h-7 max-h-7 bg-brandgold" onPress={() => { minusItem('1000') }}>
                                                    <Text className="text-white w-full h-7 leading-7 text-center font-normal">-</Text>
                                                </TouchableOpacity>
                                                <Text className="text-base text-black font-bold text-right lg:text-left leading-7 mx-3">{items['1000']}</Text>
                                                <TouchableOpacity className="w-7 h-7 max-h-7 bg-brandgold" onPress={() => { plusItem('1000') }}>
                                                    <Text className="text-white w-full h-7 leading-7 text-center font-normal">+</Text>
                                                </TouchableOpacity>
                                            </View>
                                            <View className="w-2/5 lg:w-1/5 mt-3 lg:mt-0">
                                                <Text className="text-base text-black font-bold text-right lg:text-center">HKD${items.total1000.toLocaleString()}</Text>
                                            </View>
                                        </View>
                                    }

                                    {
                                        haveItems &&
                                        <>
                                            <View className="w-full flex flex-row justify-start items-center py-10 px-4">
                                                <View className="flex flex-row justify-start items-center w-0 lg:w-3/5">

                                                </View>
                                                <View className="w-1/2 lg:w-1/5">
                                                    <Text className="text-xl text-black font-bold text-left lg:text-center">{i18n.t("promotions.total")}</Text>
                                                </View>
                                                <View className="w-1/2 lg:w-1/5">
                                                    <Text className="text-xl text-black font-bold text-right lg:text-center">HKD${items.total}</Text>
                                                </View>
                                            </View>

                                            <TouchableOpacity
                                                className="w-full h-10 max-h-10 bg-brandgold mt-4 md:w-[300px] md:m-auto md:block md:text-center"
                                                onPress={() => initPayment()}
                                            >
                                                <Text className="text-white w-full h-10 leading-10 text-center font-normal uppercase">{i18n.t("promotions.checkout")}</Text>
                                            </TouchableOpacity>

                                            <Text
                                                className="text-black underline text-center mt-4"
                                                onPress={() => navigation.push("Promotions")}
                                            >
                                                {i18n.t("promotions.continue_shopping")}
                                            </Text>
                                        </>
                                    }
                                </View>

                                <Text className="text-black text-sm mt-6 mb-1.5 uppercase font-Crimson">{i18n.t("promotions.tnc")}</Text>

                                <View className="mb-2 flex-row">
                                    <Text className="text-sm text-[#84818A] font-Crimson">1.</Text>
                                    <Text className="flex-1 pl-2 text-sm text-[#84818A] font-Crimson">
                                        {i18n.t("promotions.tnc_1")}
                                    </Text>
                                </View>
                                <View className="mb-2 flex-row">
                                    <Text className="text-sm text-[#84818A] font-Crimson">2.</Text>
                                    <Text className="flex-1 pl-2 text-sm text-[#84818A] font-Crimson">
                                        {i18n.t("promotions.tnc_2")}
                                    </Text>
                                </View>
                                <View className="mb-2 flex-row">
                                    <Text className="text-sm text-[#84818A] font-Crimson">3.</Text>
                                    <Text className="flex-1 pl-2 text-sm text-[#84818A] font-Crimson">
                                        {i18n.t("promotions.tnc_3")}
                                    </Text>
                                </View>
                                <View className="mb-2 flex-row">
                                    <Text className="text-sm text-[#84818A] font-Crimson">4.</Text>
                                    <Text className="flex-1 pl-2 text-sm text-[#84818A] font-Crimson">
                                        {i18n.t("promotions.tnc_4")}
                                    </Text>
                                </View>
                                <View className="mb-2 flex-row">
                                    <Text className="text-sm text-[#84818A] font-Crimson">5.</Text>
                                    <Text className="flex-1 pl-2 text-sm text-[#84818A] font-Crimson">
                                        {i18n.t("promotions.tnc_5")}
                                    </Text>
                                </View>
                                <View className="mb-2 flex-row">
                                    <Text className="text-sm text-[#84818A] font-Crimson">6.</Text>
                                    <Text className="flex-1 pl-2 text-sm text-[#84818A] font-Crimson">
                                        {i18n.t("promotions.tnc_6")}
                                    </Text>
                                </View>
                                <View className="mb-2 flex-row">
                                    <Text className="text-sm text-[#84818A] font-Crimson">7.</Text>
                                    <Text className="flex-1 pl-2 text-sm text-[#84818A] font-Crimson">
                                        {i18n.t("promotions.tnc_7")}
                                    </Text>
                                </View>
                                <View className="mb-2 flex-row">
                                    <Text className="text-sm text-[#84818A] font-Crimson">8.</Text>
                                    <Text className="flex-1 pl-2 text-sm text-[#84818A] font-Crimson">
                                        {i18n.t("promotions.tnc_8")}
                                    </Text>
                                </View>
                                <View className="mb-2 flex-row">
                                    <Text className="text-sm text-[#84818A] font-Crimson">9.</Text>
                                    <Text className="flex-1 pl-2 text-sm text-[#84818A] font-Crimson">
                                        {i18n.t("promotions.tnc_9")}
                                    </Text>
                                </View>
                                <View className="mb-2 flex-row">
                                    <Text className="text-sm text-[#84818A] font-Crimson">10.</Text>
                                    <Text className="flex-1 pl-2 text-sm text-[#84818A] font-Crimson">
                                        {i18n.t("promotions.tnc_10")}
                                    </Text>
                                </View>

                                {
                                    !isLoggedIn &&
                                    <TouchableOpacity className="w-full h-10 max-h-10 bg-brandgold mt-4" onPress={() => { navigation.push("Login") }}>
                                        <Text className="text-white w-full h-10 leading-10 text-center font-normal font-PingFangSC">{i18n.t("promotions.login_purchase")}</Text>
                                    </TouchableOpacity>
                                }
                            </View>
                        </View>



                        <Footer />
                        <CookieConsent />
                    </ScrollView>
                </SafeAreaView>
            </ImageBackground>

            {
                overlay &&

                <View className="top-0 right-0 bottom-0 left-0 justify-center items-center bg-[#00000075]" style={{ position: "fixed" }}>
                    <View className="w-11/12 max-w-lg bg-white px-6 py-3 relative">
                        {
                            payStatus == "success" &&
                            <>
                                <TouchableOpacity
                                    className="absolute right-1 top-1"
                                    onPress={() => {
                                        navigation.push('Coupon')
                                    }}
                                >
                                    <Image className="w-5 h-5" source={require("../assets/btn-close.png")} />
                                </TouchableOpacity>

                                <Text className="text-xl font-semibold text-brandgold text-center pt-11 pb-4 uppercase font-Crimson">
                                    {i18n.t("promotions.payment_success")}
                                </Text>

                                {
                                    items["100"] > 0 &&
                                    <Text className="text-base text-black text-center py-2">{items["100"]} X  HKD$500 {i18n.t("promotions.evoucher")}</Text>
                                }

                                {
                                    items["500"] > 0 &&
                                    <Text className="text-base text-black text-center py-2">{items["500"]} X  HKD$1,000 {i18n.t("promotions.evoucher")}</Text>
                                }

                                {
                                    items["1000"] > 0 &&
                                    <Text className="text-base text-black text-center py-2">{items["1000"]} X  HKD$5,000 {i18n.t("promotions.evoucher")}</Text>
                                }

                                {/* <Text className="text-xs text-[#84818A] text-center pb-3.5 font-Crimson">
                                    {i18n.t("promotions.successfully")}
                                </Text> */}

                                <View className="text-right flex items-end mb-8">
                                    <TouchableOpacity
                                        className="w-full h-8 max-h-8 bg-brandgold mt-6 mr-0"
                                        onPress={() => { navigation.push('Coupon') }}
                                    >
                                        <Text className="text-white w-full h-8 leading-8 text-center font-normal font-PingFangSC uppercase">{i18n.t("promotions.view_vouchers")}</Text>
                                    </TouchableOpacity>
                                </View>
                            </>
                        }
                        {
                            payStatus == "failed" &&
                            <>
                                <TouchableOpacity
                                    className="absolute right-1 top-1"
                                    onPress={() => {
                                        setOverlay(false)
                                    }}
                                >
                                    <Image className="w-5 h-5" source={require("../assets/btn-close.png")} />
                                </TouchableOpacity>

                                <Text className="text-xl font-semibold text-brandgold text-center pt-11 pb-4 uppercase font-Crimson">
                                    {i18n.t("promotions.payment_failed")}
                                </Text>

                                <Text className="text-base text-black font-bold font-NunitoSans text-center py-2">{i18n.t("promotions.try_again")}</Text>

                                <View className="text-right flex items-end mb-8">
                                    <TouchableOpacity
                                        className="w-full h-8 max-h-8 bg-brandgold mt-4 mr-0"
                                        onPress={() => { setOverlay(false) }}
                                    >
                                        <Text className="text-white w-full h-8 leading-8 text-center font-normal font-PingFangSC uppercase">{i18n.t("promotions.close")}</Text>
                                    </TouchableOpacity>
                                </View>
                            </>
                        }
                    </View>
                </View>
            }

            <Modal animationType="slide" visible={paymentWebview}>
                <Text className="text-center font-medium leading-8 text-base text-red-500">Note: Please do not refresh or close your browser until your payment has been confirmed. Time remaining: {formatCountdown(paymentRemain)}</Text>
                <WebView
                    source={{ uri: paymentURL }}
                    style={{ marginTop: 32 }}
                    onLoad={(syntheticEvent) => {
                        const { nativeEvent } = syntheticEvent;
                        console.log(nativeEvent);
                        //this.url = nativeEvent.url;
                    }}
                    onNavigationStateChange={(navState) => {
                        console.log(navState);
                    }}
                    scalesPageToFit={false}
                    onMessage={(event) => {
                        let data = {
                            log: JSON.stringify(event.nativeEvent.data),
                            region: API_REGION,
                            memberCode: memberCode,
                            invoiceno: paymentDetail.invoiceNo
                        }

                        callbackLog(data, log => {
                            console.log(event.nativeEvent.data);
                        })

                        if (event.nativeEvent.data.paymentResult) {
                            let resCode = event.nativeEvent.data.paymentResult.respCode;
                            console.log(resCode);

                            if (resCode == "2000") {
                                setTimeout(() => {
                                    setIsLoading(true);
                                    setPaymentWebview(false);
                                    checkPayment()
                                    // clearKeepCheckPayment();
                                    // CheckPayment();
                                    console.log("Payment ended");
                                }, 3000);
                            }
                        }
                    }}
                />
            </Modal>
        </View>
    );
};

export default ShoppingCart;
